/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".badge[_ngcontent-%COMP%]{top:-8px;left:-2px}.badge-error[_ngcontent-%COMP%]{background-color:#ee0006;color:#fff}.badge-warning[_ngcontent-%COMP%]{background-color:#ffd71e;color:#1a1d1e}"];
export { styles as styles };
